<template>
    <div class="all" ref="all">
		<div class="report-naver bg-white" :style="{top:high+'px'}">
			<div class="ac">
			    <button class="btn dib btn-jbblue" @click="addCompetPlan"><i class="icons add-icon"></i>新建竞对方案</button>
			</div>
			<ul class="report-list mt20">
			    <li v-for="(item,index) in reportPlanList" :key="index">
					<a class="icons del-sm-icon fr ml10" title="删除" href="javascript:void(0);" @click="delReportPlan(item.id)"></a>
					<span class="ovhidden cp" :class="{curr:currIndex === index}" @click="changePlan(index);">{{item.compareName}}</span>
				</li>
			</ul>
		</div>
		<!-- 左边 -->
		<div class="pr210">
			<!-- 筛选 -->
			<div class="screen clearfix" v-show="isCompetPlan">
				<!-- <h2 class="fl fs18">{{reportTit}}</h2> -->
				<div class="corm fl clearfix">
					<router-link class="element cp" to="/competingReport">报告列表</router-link>
					<router-link class="element cp" to="/customTemplate">自定义报告模板</router-link>
				</div>
				<div class="fr">
					<button class="btn btn-jbblue" @click="addNewReport"><i class="icons add-icon"></i>新建竞对报告</button>
				</div>
			</div>
			<!-- 预警信息列表 -->
			<div class="warp mt20" v-show="isCompetPlan">
				<div class="warp-body">
					<table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
						<colgroup>
							<col width="45%"> 
							<col width="17%"> 
							<col width="20%"> 
							<col width="20%">
						</colgroup>
						<thead>
							<tr>
								<th>报告名称</th>
								<th>创建时间</th>
								<th>简报状态</th>
								<th>操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item,index) in reportList" :key="index">
								<td>{{item.briefdoc_name}}</td>
								<td>{{item.create_time}}</td>
								<td>
									<div>
										<div class="line dib w60" >
											<div class="in" :style="{width:item.progress+'%'}"></div>
										</div>
										<span class="color-blue" :style="{left:item.progress+'%'}">{{item.progress}}%</span>
									</div>
								</td>
								<td>
									<div class="table-all-icons">
										<span v-if="item.progress<100">
											<i class="icons eye-icon disabled" title="预览"></i>
											<i class="icons word-icon disabled" title="下载Word"></i>
											<i class="icons pdf-icon disabled" title="下载PDF"></i>
											<!-- <i class="icons refresh-icon disabled" title="刷新简报" ></i> -->
											<i class="icons send-icon disabled" title="发送简报"></i>
											<i class="icons del-icon disabled" title="删除简报"></i>
										</span>
										<span v-else>
											<a class="icons eye-icon" title="预览" target="_blank" :href="item.html"></a>
											<i class="icons word-icon disabled" title="下载Word" v-if="item.word==''"></i>
											<i class="icons word-icon" title="下载Word" @click="downWord(item.word)" v-if="item.word!=''"></i>
											<i class="icons pdf-icon disabled" title="下载PDF" v-if="item.pdf==''"></i>
											<i class="icons pdf-icon" title="下载PDF" @click="downPdf(item.pdf)" v-if="item.pdf!=''"></i>
											<!-- <i class="icons refresh-icon" title="刷新简报" @click="reFresh(item.id)" ></i> -->
											<i class="icons send-icon" title="发送简报" @click="sendReport(item.id)" ></i>
											<i class="icons del-icon" title="删除简报" @click="delReport(item.id)"></i>
										</span>
										
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
					<!-- 分页 -->
					<page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
				</div>
			</div>
			<div class="warp" v-show="!isCompetPlan">
				<div class="warp-body">
					<div class="no-data">
						<span class="text"><button class="btn db btn-jbblue" @click="addCompetPlan"><i class="icons add-icon"></i>新建竞对方案</button></span>
					</div>
				</div>
			</div> 
		</div>
		<!-- 新建竞对方案 -->
		<Dialog ref="reportPlanModal" type="normal" width="595" title="新建竞对方案" :callback="reportPlanEnter">
		    <div slot="mdBox">
		        <div class="form-warp name-width0">
		            <div class="item clearfix modal-h420">
		                <span class="name w110"><i class="color-red">*</i> 选择对比方案 <label class="color-8a8a99 fs12">（最多可选择3个方案进行对比分析）</label></span>
		                <div class="input-father checkbox-group mt-5">
		                    <label class="checkbox-box reportPlanList" v-for="(item,index) in planList2" :key="index" >
		                        <label class="checkbox-warp fl" @click="choseReptPlan(index)" :class="{'curr':reportPlanType.indexOf(item.name) != -1 }">
		                            <input name="" type="checkbox" class="checkbox" v-model="reportPlanType" :value="item.name" /> 
		                            <i class="icons checkbox-icon"></i>
		                        </label>
		                        <div class="ovhidden" :title="item.name">{{item.name}}</div>
		                    </label>
		                </div>
		            </div>
                    <div class="item clearfix">
                        <span class="name fl"><i class="color-red">*</i> 选择模板：</span>
                        <div class="fl">
                            <span class="drop-down">
                                <button class="btn btn-lightblue datepicker-range"><span class="text">请选择竞对报告模板</span> <i class="icons"></i></button>
                                <ul class="option">
                                    <li class="ovhidden" v-for="(item,index) in reportTemplate" :key="index" @click="choseTemple(item.id)">{{item.tplName}}</li>
                                </ul>
                            </span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl"><i class="color-red">*</i> 竞对时间：</span>
                        <div class="fl">
                                <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"  show-buttons  @confirm="selectedDate"/>
                        </div>
                    </div>
		        </div>
		    </div>
		</Dialog>
		<!-- 新建竞对方案删除 -->
		<Dialog ref="delReportPlanModal" :callback="delReportPlanEnter" type="confirm">
		    <div slot="mdBox">
		        <p class="ac">是否删除此方案</p>
		    </div>
		</Dialog>
		
        <Dialog ref="dialog" title="新建竞对报告" width="518" btnText="保存" :callback="confirm">
            <div slot="mdBox" >
                <div class="modal-inside">
                    <div class="form-warp name-width0">
                        <div class="item clearfix">
						    <span class="name fl"><i class="color-red">*</i> 选择模板：</span>
						    <div class="fl">
						        <span class="drop-down">
						            <button class="btn btn-lightblue datepicker-range"><span class="text">请选择竞对报告模板</span> <i class="icons"></i></button>
						            <ul class="option">
						                <li class="ovhidden" v-for="(item,index) in reportTemplate" :key="index" @click="choseTemple(item.id)">{{item.tplName}}</li>
						            </ul>
						        </span>
						    </div>
						</div>
                        <div class="item clearfix">
                            <span class="name fl"><i class="color-red">*</i> 竞对时间：</span>
                            <div class="fl">
                                 <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"  show-buttons  @confirm="selectedDate"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog ref="sendDialog" title="发送简报" :callback="sendModal" width="640">
            <div slot="mdBox" >
                <div class="modal-inside">
                    <div class="form-warp name-width0">
                        <div class="item mt10 clearfix report-drop">
                            <span class="name fl">微信:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(1)">
                                <input class="input-text" type="text" placeholder="请点击输入框添加接收人的微信账号" v-model.trim="reportForm.wx" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="wxList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in wxList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedWx.toString().indexOf(item.username) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedWx"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="ovhidden ac">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                        <div class="item mt15 clearfix report-drop">
                            <span class="name fl">邮箱:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(2)">
                                <input class="input-text" type="text" placeholder="填写接收人邮箱地址，多个地址请用,隔开" v-model.trim="reportForm.email" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="emailList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in emailList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedEmail.toString().indexOf(item.username) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedEmail"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="ovhidden ac">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                        <div class="item mt15 clearfix report-drop">
                            <span class="name fl">手机:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(3)">
                                <input class="input-text" type="text" placeholder="填写接收人手机号码，多个号码请用,隔开，使用短信接收可能会产生额外费用" v-model="reportForm.tel" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="telList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in telList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedTel.toString().indexOf(item.username) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedTel"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="hidden ac">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog ref="delDialog" :callback="delModal">
            <div slot="mdBox" >
                <div class="ac">确定删除报告吗？</div>
            </div>
        </Dialog>
        <Dialog ref="sendTipDialog" type="alert">
            <div slot="mdBox">
                <vue-scroll :ops="ops" :style="sendTipList.length > 8 ? 'height:168px' : ''">
                    <p v-for="(item,index) in sendTipList" v-html="item" :key="index"></p>
                </vue-scroll>
            </div>
        </Dialog>
	</div>
</template>
<script>
import page from '../../components/page.vue';
import Dialog from '../../components/dialog.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    data() {
        const min = new Date(2019, 5, 1, 0, 0, 0)
        const max = new Date(2019, 8, 30, 0, 0, 0)
        return {
            // caseId:'',
            sid:'',//竞对报告ID
			high:'',//class为all的距离顶部的距离
			reportPlanType:[],//所选竞对方案
			reportPlanList:[],//竞对方案列表
			currIndex:0,//当前的竟对方案序号
			planList2:[],//新建竞对方案中的方案列表
            reportTit:'',
            isCompetPlan:false,
            reportList:[],//竟对报告列表
            reportListId:[],
            reportTemplate:[],
            currentPage: 1,//当前页码
            limit: 20,//每页显示条数
            totalCount:0,//总条数
            // min: min,
            // max: max,
            startTime:null,
            endTime:null,
            templateId:0,
            reportId:0,
            timeRange: [min, max],
            statusList:[],//报告状态
            isShow:true,
            setTimer:null,
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            scrollH:'150px',
            nodata:false,
            reportForm:{},
            checkedWx:[],
            curWx:'', 
            curEmail:'', 
            checkedEmail:[],
            curTel:'', 
            checkedTel:[],
            wxList:[],
            emailList:[],
            telList:[],
            sendTipList:[], //发送提示成功
            isShowNew:true
        }
    },
    components:{
        page,Dialog,VueDatepickerLocal
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
			that.reportPlanAjax();
			that.getTemplateList();
            that.initialTime();
            that.getUserMethod('wx');
            that.getUserMethod('email');
            that.getUserMethod('tel');
        })
    },
    watch:{
        checkedWx(){
            let that=this,nameArr=[],idArr=[];
            that.checkedWx.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curWx = idArr.toString();
            that.$set(that.reportForm,'wx',tempWx);
        },
        checkedEmail(){
            let that=this,nameArr=[],idArr=[];
            that.checkedEmail.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curEmail = idArr.toString();
            that.$set(that.reportForm,'email',tempWx);
        },
        checkedTel(){
            let that=this,nameArr=[],idArr=[];
            that.checkedTel.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curTel = idArr.toString();
            that.$set(that.reportForm,'tel',tempWx);
        }
    },
    beforeDestroy() {
        clearInterval(this.setTimer);
    },
    methods: {
        //竞对方案列表
        reportPlanAjax(){
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/compare/list',null,r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.high = that.$refs.all.getBoundingClientRect().top + 33;//动态获取定位
                    that.reportPlanList = r.data;
					if(r.data.length <= 0){
					    that.isCompetPlan = false;
					}else{
					    that.isCompetPlan = true;
						that.changePlan(0);
					}
                });           
            })
        },
        // 获取模板列表
		getTemplateList (){
			let that = this;
			that.$api.get('monitor/compare/tpl-all-list',null,r=>{
				that.$parent.showLoad = false;
			    that.$utils.returnCode(r,function(){
			        that.reportTemplate = r.data;
			    });
			});
		},
        //新建竞对方案
        addCompetPlan(){
            let that = this;
            that.$parent.loadModal(true,'正在获取数据');
            that.reportPlanType = [];
            that.$api.get('monitor/compare/schemes',null,r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.planList2 = r.data;
                    that.$refs.reportPlanModal.showMaskFun();
                });           
            })  
        },
		// 保存竟对报告
		reportPlanEnter(){
            let that = this,schemeIdArr=[];
            if(that.templateId==0){
			    that.$utils.alertText('请选择竞对报告模板',200);
			    return;
			}
            if(!that.isShowNew){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天,请重新选择时间','',2000);
                return
            }
		    that.$parent.loadModal(true,'正在提交数据...');
		    that.planList2.forEach((ele,index)=>{
		        that.reportPlanType.forEach((ele1,index1)=>{
		            if(ele.name==ele1){
		                schemeIdArr.push(ele.id)
		            }
		        })
		    });
		    let data = {
                schemeIds:schemeIdArr,
                startTime:that.startTime,
                endTime:that.endTime,
				templateId:that.templateId
		    }
		    that.$api.post('monitor/compare/create',{data:data},r =>{
                that.$parent.showLoad = false;
		        that.$utils.returnCode(r,function(){
		            that.$utils.alertText(r.msg);
		            // if(that.$parent.curCompetPlan==''){
		            //     location.reload();
		            //     return;
		            // }
		            that.isCreatePlan = true;
		            that.reportPlanAjax();
		            that.$refs.reportPlanModal.closeMask();
		        });           
		    })
		},
        choseReptPlan(i){
            let that = this;
            let len = that.reportPlanType.length;
            let isChose =  $('.reportPlanList .checkbox-warp').eq(i).find('.checkbox').prop('checked');
            //console.log(that.reportPlanType);
            if(len>2 && (isChose==true)){
                $('.reportPlanList .checkbox-warp').eq(i).removeClass('curr');
                $('.reportPlanList .checkbox-warp').eq(i).find('.checkbox').prop('checked',false);
                that.$utils.alertText('最多只能选择3个方案哦~',200);
            }
        },
        //删除竞对方案
        delReportPlan(id){
            let that = this;
            that.delReptId = id;
            that.$refs.delReportPlanModal.showMaskFun();
        },
        // 确认删除
        delReportPlanEnter() {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.get('monitor/compare/delete',{id:that.delReptId},r =>{
				that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText(r.msg);
                    that.isCreatePlan = true;
                    that.reportPlanAjax();
                    that.$refs.delReportPlanModal.closeMask();
                });           
            })
        },
        // 选择竞对方案
        changePlan(index){
            let that = this;
			let list = that.reportPlanList;
			that.currIndex = index;
			// r.data[that.currIndex].id,r.data[that.currIndex].compareName
            that.sid = list[index].id;
			that.reportTit = list[index].compareName;
            that.dataAjax();
        },
		// 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,7);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], 0)
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1],0)
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startTime = this.$utils.dateConversion(min,1);
            this.endTime = this.$utils.dateConversion(max,1);
        },
        
        dataAjax(){
            let that = this;
            that.reportListId = [];
            clearInterval(this.setTimer);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/compare/report-list',{compareId:that.sid,perpage:that.limit,page:that.currentPage},r=>{
                that.$parent.loadModal(false);
                that.$utils.returnCode(r,function(){
                    that.reportList = r.data.list;
                    r.data.list.forEach(ele=>{
                        if(ele.status!=3){
                            that.reportListId.push(ele.id);
                        }
                    });
                    that.totalCount = Math.floor(r.data.count);
                    if(r.data.list.length<=0){
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                        that.setTime();
                    }
                    if(that.sid != undefined){
                        that.isCompetPlan = true;
                    }else{
                       that.isCompetPlan = false; 
                    }
                });
            });
        },
        
        // 新建竞对报告
        addNewReport () {
            let that = this;
            that.$refs.dialog.showMaskFun();
        },
        confirm(){
            let that = this;
            if(that.templateId==0){
			    that.$utils.alertText('请选择竞对报告模板',200);
			    return;
			}
            if(!that.isShowNew){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天,请重新选择时间','',2000);
                return
            }
            let data = {
                "compareId":that.sid,
                "startTime":that.startTime,
                "endTime":that.endTime,
				"templateId":that.templateId
            }
            that.$refs.dialog.closeMask();
            clearInterval(that.setTimer);
            that.$parent.loadModal(true,'正在保存...'); 
            that.$api.post('monitor/compare/report-create',{data:data},r=>{
				that.$parent.loadModal(false);
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('添加成功！',200);
                    that.currentPage = 1;
                    that.dataAjax();
                });
            });
        },
        getTableData() {
           this.dataAjax()
        },
        disabledDate(time){
            //return time < this.min || time > this.max
            if(time.getTime() > new Date().getTime()) return true;
        },
        //选择时间回调
        // selectedDate () {
        //     let that = this;
        //     that.watch = false;
        //     that.startDate = this.$utils.dateConversion(this.timeRange[0],1);
        //     that.endDate = this.$utils.dateConversion(this.timeRange[1],1);
        //     let day = that.$utils.getDateDiff(that.startDate,that.endDate);
        //     if(day > that.$parent.timeSection){
        //         that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天','',1500);
        //         return;
        //     }
        //     that.getMediaPlatform();
        //     that.getNewsList(0);
        // },
        selectedDate (date) {
            let that = this;
            let timeRange = that.timeRange;
            that.isShowNew = true;
            //进页面获取时间数据
            that.startTime = that.$utils.dateConversion(timeRange[0],1);
            that.endTime = that.$utils.dateConversion(timeRange[1],1);
            let day = that.$utils.getDateDiff(that.startTime,that.endTime);
            // console.log(that.startTime);
            if(day > that.$parent.timeSection){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天','',1500);
                that.isShowNew = false;
                return;
            }
        },
        choseTemple(id){
            this.templateId = id;
        },
        //删除报告
        delReport(id){
            let that = this;
            that.reportId = id;
            that.$refs.delDialog.showMaskFun();
        },
        delModal(){
            let that = this;
            that.$refs.delDialog.closeMask();
            that.$parent.loadModal(true,'正在删除...');
            that.$api.get('monitor/compare/report-delete',{id:that.reportId},r=>{
				that.$parent.loadModal(false);
                that.$utils.returnCode(r,function(){
                    that.dataAjax();
                    that.currentPage = 1;
                });
            });
        },
        //刷新报告
        // reFresh(id){
        //     let that = this;
        //      clearInterval(this.setTimer);
        //      that.$api.get('monitor/compare/report-refresh',{id:id},r=>{
        //         that.$parent.returnCode(r,function(){
        //             that.reportListId.push(id);
        //             that.setTime();
        //         });
        //     });
        // },
        //发送报告
        sendReport(id){
            let that = this;
            that.reportId = id;
            that.$refs.sendDialog.showMaskFun();
        },
        sendModal(){
            let that = this,contentArr=[];
            if((that.reportForm.wx == undefined ||that.reportForm.wx == '') && (that.reportForm.email == undefined || that.reportForm.email == '')&&(that.reportForm.tel == undefined ||that.reportForm.tel == '')){
                that.$utils.alertText('接收人的微信账号,邮箱地址,手机号码至少填写一项',350,3000);
                return;
            }
            if(that.curWx!=''){
                contentArr.push(that.curWx);
            }
            if(that.curEmail!=''){
                contentArr.push(that.curEmail);
            }
            if(that.curTel!=''){
                contentArr.push(that.curTel);
            }
            let content = contentArr.toString();
            that.$refs.sendDialog.closeMask();
            that.$parent.loadModal(true,'正在发送...'); 
            that.$api.post('monitor/compare/send-compare-report',{rid:that.reportId,contact:content}, r => {
                that.$parent.loadModal(false);
                that.$utils.returnCode(r,function(){
                    //that.$utils.alertText('发送成功！',150); 
                    that.$refs.sendTipDialog.showMaskFun();
                    that.sendTipList = r.msg;
                })
            });
        },
        //获取微信联系人
        getUserMethod(type){
            let that = this;
            that.$api.get('user/contact/list',{type:type}, r => {
                that.$utils.returnCode(r,function(){
                    if(type==='wx'){
                        that.wxList = r.data;
                    }else if(type==='email'){
                        that.emailList = r.data;
                    }else{
                        that.telList = r.data;
                    }
                })
            });
        },
        isHasUser(type){
            let that = this;
            if(that.wxList=='' && type ==1){
                that.$utils.alertText('请到“我的联系人”添加微信账号！',300);
            }else if(that.emailList=='' && type ==2){
                that.$utils.alertText('请到“我的联系人”添加邮箱地址！',300);
            }else if(that.telList=='' && type ==3){
                that.$utils.alertText('请到“我的联系人”添加手机号码！',300);
            }
        },
        //简报状态
        statusModal(){
            let that = this;
            that.statusList=[];
            let len = that.reportListId.length;
            if(len<=0){
                clearInterval(that.setTimer);
                return
            }
            let data={
                compareId:that.sid,
                ids:that.reportListId
            }
            that.$api.post('monitor/compare/check-status',{data:data},r=>{
                that.$utils.returnCode(r,function(){
                    that.statusList = r.data;
                    that.reportList.forEach(ele=>{
                        if(that.statusList[ele.id]!=undefined){
                            ele.progress = that.statusList[ele.id].progress;
                            ele.html = that.statusList[ele.id].data.html;
                            ele.pdf = that.statusList[ele.id].data.pdf;
                            ele.word = that.statusList[ele.id].data.word;
                            if(ele.progress==100){
                                let ind = that.reportListId.indexOf(ele.id);
                                if(ind!=-1){
                                    that.reportListId.splice(ind,1);
                                }
                            }
                        }
                        
                    });
                });
            });
        },
        setTime(){
            let that = this;
            that.setTimer = setInterval(function(){
                that.statusModal();
            },1000);
        },
        //下载html
        showhtml(id){
            let url={path:'competDetail',query:{id:id}};
            window.open(url,'_blank')
        },
        //下载word
        downWord(url){
            window.location.href = url;
        },
        //下载pdf
        downPdf(url){
            window.open(url,'_blank')
        },
        addCompetCase(){
            this.$parent.$refs.left.addCompetPlan()
        }
	}
}
</script>




// WEBPACK FOOTER //
// src/page/competingReports/competingReport.vue